
import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actionsCheckout from '../checkout/actions';
import * as actions from "./actions";

function* fetchUserCart() {
  try {
    const result = yield call(AxiosCall, `/shop/get_cart`);
    const response = result.data.response;
    if (response === "CART_COMPLETED") {
      // We need to create another session id and call fetchUserCart again

      yield put({ type: actionsCheckout.GET_CHECKOUT_CONFIRMATION.REQUEST });
      yield call(fetchUserCart);

    }
    else {
      yield put(actions.fetchUserCartSuccess(result.data))
    }


  } catch (e) {
    yield put(actions.fetchUserCartFailure(e))
  }
}

export function* setDeliveryAddress({ payload: { id } }) {
  try {

    const result = yield call(AxiosPost, `/shop/set_delivery_address/`, { id });
    yield put(actions.setDeliveryAddressSuccess(result.data));
    // We set the next step because setting delivery address is a method that should
    // be used only in checkout and to go to the next step
  } catch (e) {
    yield put(actions.setDeliveryAddressFailure(e));
  }
}

function* setShippingType({ payload: { shipping_type } }) {
  try {
    const result = yield call(AxiosPost, `/shop/set_shipping_type/`, { shipping_type });
    yield put(actions.setShippingTypeSuccess(result.data))
  } catch (e) {
    yield put(actions.setShippingTypeFailure(e))
  }
}


export function* applyDiscount({ payload: { discount_code } }) {
  try {
    const result = yield call(AxiosPost, `/shop/apply_discount/`, { discount_code });
    yield put(actions.applyDiscountSuccess(result.data));
  } catch (e) {
    yield put(actions.applyDiscountFailure(e));
  }
}

function* fetchUserCartItems() {
  try {
    const result = yield call(AxiosCall, `/shop/get_cart_items/`);
    yield put(actions.fetchUserCartItemsSuccess(result.data.results))
  } catch (e) {
    yield put(actions.fetchUserCartItemsFailure(e))
  }
}

export function* updateCartItem({ payload: { unique_code, quantity, product_code } }) {
  try {
    // Support both presentation-based (unique_code) and direct products (product_code)
    const data = { quantity };
    if (unique_code) {
      data.unique_code = unique_code;
    } else if (product_code) {
      data.product_code = product_code;
    }
    const result = yield call(AxiosPost, `/shop/update_item/`, data);
    yield put(actions.updateCartItemSuccess(result.data.results));
  } catch (e) {
    yield put(actions.updateCartItemFailure(e));
  }
}

export function* addCartItem({ payload: { unique_code, quantity, product_code } }) {
  try {
    // Support both presentation-based (unique_code) and direct products (product_code)
    const data = { quantity };
    if (unique_code) {
      data.unique_code = unique_code;
    } else if (product_code) {
      data.product_code = product_code;
    }
    const result = yield call(AxiosPost, `/shop/add_item/`, data);
    yield put(actions.addCartItemSuccess(result.data.results));
  } catch (e) {
    yield put(actions.addCartItemFailure(e));
  }
}

function* removeCartItem(action) {
  try {
    const { itemId } = action.payload;
    const result = yield call(AxiosPost, `/shop/remove_item/`, { itemId });
    // Update cart items with the response
    yield put(actions.removeCartItemSuccess(result.data.results));
  } catch (e) {
    yield put(actions.removeCartItemFailure(e));
  }
}

export default function* cartSaga() {
  yield all([
    // watchers cart
    takeLatest(actions.FETCH_USER_CART.REQUEST, fetchUserCart),
    takeLatest(actions.SET_DELIVERY_ADDRESS.REQUEST, setDeliveryAddress),
    takeLatest(actions.SET_SHIPPING_TYPE.REQUEST, setShippingType),
    takeLatest(actions.FETCH_USER_CART_ITEMS.REQUEST, fetchUserCartItems),
    takeLatest(actions.UPDATE_CART_ITEM.REQUEST, updateCartItem),
    takeLatest(actions.REMOVE_CART_ITEM.REQUEST, removeCartItem),
    takeLatest(actions.ADD_CART_ITEM.REQUEST, addCartItem),
    takeLatest(actions.APPLY_DISCOUNT.REQUEST, applyDiscount)
  ])
}